<template lang="pug">
v-date-picker(
  v-model="dates"
  :range="range"
  :allowed-dates="allowedDates"
  :min="minDate"
  :max="maxDate"
  :picker-date.sync="pickerDate"
  :readonly="readonly"
  :show-adjacent-months="showAdjacentMonths"
  :first-day-of-week="firstDayOfWeek"
  @change="change"
  @input="input"
)
</template>

<script>
export default {
  props: ['parentDate', 'range', 'allowedDates', 'minDate', 'maxDate', 'parentPickerDate', 'readonly', 'showAdjacentMonths', 'firstDayOfWeek'],
  computed: {
    dates: {
      get() {
        return this.parentDate
      },
      set(newValue) {
        this.$emit('update:parentDate', newValue)
      }
    },
    pickerDate: {
      get() {
        return this.parentPickerDate
      },
      set(newValue) {
        this.$emit('update:parentPickerDate', newValue)
      }
    }
  },
  methods: {
    change() {
      this.$emit('change')
    },
    input() {
      this.$emit('input')
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-date-picker-title__year {
    display: none;
  }

  .v-date-picker-title__date {
    display: none;
  }

  .v-picker__title {
    padding: 0;
  }

  .v-picker__body{
    width: 100% !important;
  }

  .v-date-picker-header {
    height: 50px;
  }

  .v-date-picker-header > button {
    position: absolute !important;
    width: 24px;
    border-radius: 5px;
    color: black !important;
  }

  .v-date-picker-header > button[aria-label="Previous month"],
  .v-date-picker-header > button[aria-label="Previous year"] {
    right: 53px;
    font-size: 20px;
  }

  .v-date-picker-header > button[aria-label="Next month"],
  .v-date-picker-header > button[aria-label="Next year"] {
    right: 24px;
  }

  .v-date-picker-header > div {
    position: absolute !important;
    font-size: 14px;
    font-weight: 700;
  }

  .v-date-picker-header .v-date-picker-header__value button::after {
    font-family: "Material Design Icons";
    content: "\F0140";
    margin-left: 12px;
  }

  .v-date-picker-table th {
    font-size: 15px;
    color: var(--v-neutral400) !important;
    height: 44px;
    border-bottom: 1px solid rgb(244,244,244);
    border-top: 1px solid rgb(244,244,244);
  }

  .v-date-picker-table--date {
    height: 330px;
  }

  .v-date-picker-table .v-btn {
    height: 44px;
    width: 44px;
    font-size: 15px !important;
    font-weight: 600;
    border-radius: 8px !important;
    color: black !important;
  }

  .v-date-picker-table__current {
    border: 2px solid black;
    color: black !important;
    background-color: rgba(51, 51, 51, 0.08);
  }

  .v-date-picker-table .v-btn.v-btn--disabled {
    color: var(--v-neutral400) !important;
  }

  .v-date-picker-table .v-btn.v-btn--active {
    background-color: black !important;
    color: white !important;
    border-color:  black !important;
  }

  .v-date-picker-table--date .v-date-picker-table__events {
    bottom: 12px;
  }

  .v-date-picker-table__events > div {
    width: 5px;
    height: 5px;
  }

  .v-date-picker-table--month td .v-btn {
    margin: 0 auto;
    max-width: 140px;
    min-width: 40px;
    width: 100%;
    font-size: 15px !important;
    font-weight: 600 !important;
  }
  
  .v-date-picker-years {
    font-size: 15px;
    font-weight: 600;
    height: 290px;
    list-style-type: none;
    overflow: auto;
    text-align: center;
  }
}
</style>